import {DefaultFooter} from '@ant-design/pro-components';
import React from 'react';
import './index.less'

const Footer: React.FC = () => {
  return (
    <div className={'footerComponents'}>
      <div className="footer">
        <h2>用屋托帮，全面赋能智慧社区数字化建设</h2>
        <button>微信关注"港城智慧物业"服务号,下载App,或搜索同名小程序</button>
      </div>
      <DefaultFooter
        className={'defaultFooter'}
        copyright="屋托帮All Rights Reserved"
        links={[
          {
            key: '屋托帮官网',
            title: '',
            href: '',
            blankTarget: true,
          },
        ]}
      />
    </div>
  );
};

export default Footer;
